import React from "react";
import { Link } from "react-router-dom";
import sidebarHelper from "../../../helpers/sidebar";

export default function AdvertiseMenu({ openItem, activeItem }) {
  return (
    <li
      className={`nav-item has-treeview 
${sidebarHelper.checkOpenItem(openItem, "all-advertise")} `}
    >
      <a
        href="# "
        className={`nav-link  
${sidebarHelper.checkActiveItem(openItem, "all-advertise")} `}
      >
        <i class="nav-icon hl-advertise align-middle"></i>
        <p>
          تبلیغات
          <i className="right fa fa-angle-left"></i>
        </p>
      </a>

      <ul className="nav nav-treeview">
        <li className="nav-item">
          <Link
            to="/advertise/banner/all"
            className={`nav-link  
  ${sidebarHelper.checkActiveItem(activeItem, "add-advertise-banner")} `}
          >
            <i className="hl-add-banner nav-icon"></i>
            <p>تبلیغات بنری</p>
          </Link>
        </li>

        <li className="nav-item">
          <Link
            to="/advertise/banner-generator"
            className={`nav-link  
              ${sidebarHelper.checkActiveItem(
                activeItem,
                "banner-generator"
              )} `}
          >
            <i className="hl-add-banner nav-icon"></i>
            <p> بنرساز هایلات</p>
          </Link>
        </li>

        <li className="nav-item">
          <a className="nav-link   d-flex justify-content-between">
            <span>
              <i className="hl-ad-native nav-icon"></i>
              <p>تبلیغات همسان</p>
            </span>
            <span className="badge badge-success">به زودی</span>
          </a>
        </li>

        <li className="nav-item">
          <a className="nav-link   d-flex justify-content-between">
            <span>
              <i className="hl-ad-push nav-icon"></i>
              <p>تبلیغات پوش</p>
            </span>
            <span className="badge badge-success">به زودی</span>
          </a>
        </li>
      </ul>
    </li>
  );
}
